var map = {
	"./${lang}.json": [
		9258,
		43
	],
	"./de.json": [
		3517
	],
	"./en.json": [
		1700,
		627
	],
	"./fr.json": [
		6493,
		273
	],
	"./it.json": [
		7253,
		468
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6038;
module.exports = webpackAsyncContext;